module.exports = __webpack_public_path__ + "images/questions/qa_title_ballon_pattern_a2e74f43f1f82824f18ebec404ab8e17.png";